import { ROUTES } from '@/common/constants/routes';
import { AlertOffboardingMeal } from '@/common/containers/Dashboard/Home/AlertOffboardingMeal/AlertOffboardingMeal';
import { HomeLayout } from '@/common/containers/Dashboard/Home/HomeLayout/HomeLayout';
import { PocketCardsGrid } from '@/common/containers/Dashboard/Home/PocketCardsGrid/PocketCardsGrid';
import { useFeatures } from '@/common/integrations/feature-flag/feature-flag.hooks';
import {
  useITHomePageModal,
  useITPocketCards,
  useITPrimaryActions,
  useITSecondaryActions,
} from './ITHomePage.utils';

export function ITHomePage() {
  const {
    features: { ff_sea_activity },
  } = useFeatures();
  const primaryActions = useITPrimaryActions();
  const pocketCards = useITPocketCards();
  const secondaryActions = useITSecondaryActions();
  const modal = useITHomePageModal();

  return (
    <>
      <HomeLayout
        alertsSlot={<AlertOffboardingMeal />}
        primaryActionsSlot={primaryActions}
        pocketCardsSlot={<PocketCardsGrid>{pocketCards}</PocketCardsGrid>}
        secondaryActionsSlot={secondaryActions}
        activityRoute={ff_sea_activity ? ROUTES.HOME_ACTIVITY : undefined}
      />
      {modal}
    </>
  );
}
